import React, { PureComponent, Fragment } from 'react';
import ReactModal from 'react-modal';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToggleFooterModal } from '../../actions/utils';

class Footer extends PureComponent{

  constructor(){
    super();
    this.state = {
      showFooterModal:false,
      footerURL:""
    }
    this.openFooterModal = this.openFooterModal.bind(this);
    this.closeFooterModal = this.closeFooterModal.bind(this);
    this.onFooterHandler = this.onFooterHandler.bind(this);
  }

  componentDidUpdate(prevProp, prevState){
    if(prevProp.toggleModal !== this.props.toggleModal){
      if(this.props.toggleModal.isOpen){
        this.openFooterModal(this.props.toggleModal.link);
      }else{
        this.closeFooterModal()
      }
    }
  }

  openFooterModal(url){
    ReactGA.pageview('book.busabout.com/modal/footer-modal');
    this.setState({showFooterModal:true, footerURL:url});
  }

  closeFooterModal(){
    this.setState({showFooterModal:false, footerURL:""});
    this.props.ToggleFooterModal("", false);
  }

  onFooterHandler(e){
    e.preventDefault();
    this.openFooterModal(e.target.href);
  }

  render(){
    return (
      <Fragment>
        <footer id="footer" className="discovery-footer">

          <div className="row expanded footer-container">

            <div className="columns small-12 columns end">
                <div className="row">
                    <div className="columns small-12 medium-5 no-padding">
                     <p className="secure-text">
                       <img src="https://images.contentful.com/3ng3kfj0qs70/37bMJCsP4s4eOsiWMimqWi/557725e5f24abae4e9e8f8b2873dc184/icon-secure.svg" alt="secure icon" />
                       Secure online payment
                     </p>

                     <ul>
                       <li><a href="https://www.busabout.com/terms-conditions?SQ_DESIGN_NAME=simple" rel="noopener noreferrer" target="_blank" onClick={this.onFooterHandler}>Terms</a>|</li>
                       <li><a href="https://www.busabout.com/faqs?SQ_DESIGN_NAME=simple" rel="noopener noreferrer" target="_blank" onClick={this.onFooterHandler}>Privacy Policy</a>|</li>
                       <li><a href="https://www.busabout.com/privacy-policy?SQ_DESIGN_NAME=simple" rel="noopener noreferrer" target="_blank" onClick={this.onFooterHandler}>FAQ</a>|</li>
                       <li><a href="https://agent.radicaltravel.com/" rel="noopener noreferrer" target="_blank">Agent login</a></li>
                     </ul>

                   </div>
                   <div className="columns small-12 medium-7 end no-padding">
                     <p className="copyright-text">Busabout is a proud part of The Travel Corporation family of brands. &nbsp;
                       <br/>
                      © Copyright {(new Date().getFullYear())} Busabout. All Rights Reserved.
                     </p>
                   </div>
               </div>
             </div>
         </div>
        </footer>

        <ReactModal
            className="footer-modal"
            overlayClassName="modal-overlay semi-white"
            isOpen={this.state.showFooterModal}
            onRequestClose={this.closeFooterModal}
            contentLabel="Footer modal">

            <div className="row">
              <div className="column small-12">
                  <div className="iframe-container">
                    <iframe title="Footer modal" src={this.state.footerURL}></iframe>
                  </div>
              </div>
            </div>


           <button className="modal-close orange" onClick={this.closeFooterModal}>
             &#x2715;
           </button>
         </ReactModal>

      </Fragment>
    )
  }
}

function mapStateToProps(state){
  return {
    toggleModal:state.toggleModal
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    ToggleFooterModal
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/shared/footer.js